const STORAGE_KEY = "state";

/**
 * Версия схемы снимка. Меняем её каждый раз, когда меняется набор или формат
 * сохраняемых полей: снимок чужой версии игнорируется целиком. Иначе после
 * релиза в стор поднимаются поля в неактуальном формате, и это вылезает уже
 * падениями и пустыми списками на проде, которые лечатся только ручной
 * очисткой localStorage.
 */
const VERSION = 7;

let persistenceStopped = false;

/**
 * Сохраняем только выбор самого пользователя: активное отделение и кассу,
 * открытые меню, выбранную очередь и черновик формы найма.
 *
 * Данные, которые приходят с сервера (очереди заявок, список отделений с
 * курсами и балансами, тикеты helpdesk, состояние задачи Camunda), намеренно
 * не сохраняем: после перезагрузки они всё равно перезапрашиваются, а до
 * этого показывали бы устаревшие суммы и курсы.
 *
 * userContext сюда тоже не попадает - единственный источник правды по токенам
 * и пользователю это отдельный ключ localStorage.userContext, из которого
 * header гидрируется при старте (см. HeaderReducer). Иначе токены живут в двух
 * местах, а обновляет их при refresh только axios и только в своём ключе.
 */
const pickPersisted = (state: any) => ({
    header: {
        activeDepartmentId: state?.header?.activeDepartmentId,
        workWithKassa: state?.header?.workWithKassa,
        menuBarOpen: state?.header?.menuBarOpen,
        queueMenuBarOpen: state?.header?.queueMenuBarOpen,
        selectedMenu: state?.header?.selectedMenu,
        selectedReport: state?.header?.selectedReport,
        selectedQueueMenu: state?.header?.selectedQueueMenu,
        activeQueue: state?.header?.activeQueue,
    },
    departmentReducer: {
        activeDepartmentId: state?.departmentReducer?.activeDepartmentId,
        activeKassaId: state?.departmentReducer?.activeKassaId,
        activeRegion: state?.departmentReducer?.activeRegion,
        activeDepartmentLandingAddress: state?.departmentReducer?.activeDepartmentLandingAddress,
    },
    employee: state?.employee,
});

export const loadState = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);

        if (!raw) {
            return undefined;
        }

        const parsed = JSON.parse(raw);

        // Снимок другой версии - как и старый формат без version - не поднимаем.
        return parsed?.version === VERSION ? parsed.state : undefined;
    } catch (error) {
        return undefined;
    }
};

export const saveState = (state: any) => {
    // После выхода снимок больше не пишем: saveState висит на throttle, и
    // отложенный вызов сработал бы уже после очистки (редирект на /login
    // происходит раньше, чем истечёт таймер), вернув данные вышедшего
    // пользователя обратно в localStorage.
    if (persistenceStopped) {
        return;
    }

    try {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ version: VERSION, state: pickPersisted(state) })
        );
    } catch (error) {
        // переполнение квоты / приватный режим - работаем без снимка
        console.warn("Не удалось сохранить состояние в localStorage", error);
    }
};

/**
 * Вызывается при выходе (см. clearSession). Снимок предыдущего пользователя не
 * должен достаться следующему на том же компьютере: раньше удалялся только
 * userContext, а в ключе state оставались его активное отделение, касса,
 * очереди и заявки.
 */
export const clearPersistedState = () => {
    persistenceStopped = true;

    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.warn("Не удалось очистить сохранённое состояние", error);
    }
};
